import React from 'react'
import styles from './Breadcrumb.sass'

export interface BreadcrumbItem {
  id: string
  title: string
  onClick?: () => void
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export default function Breadcrumb({ items, ...rest }: BreadcrumbProps) {
  return (
    <nav className={styles.breadcrumb} {...rest}>
      {items.map((item, index) => (
        <React.Fragment key={item.id}>
          {index > 0 && <span className={styles.separator}>{'>'}</span>}
          {index === items.length - 1 ? (
            <span className={styles.breadcrumbCurrent}>{item.title}</span>
          ) : (
            <button
              className={styles.breadcrumbLink}
              onClick={item.onClick}
              type="button"
            >
              {item.title}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  )
}
